import React from 'react';
import { Field } from '../../../types/generic';
import { Checkbox, CheckboxProps, FormControlLabel, FormGroup, FormHelperText } from '@mui/material';
import { getHelperText } from '../../../utils/form';

interface FormCheckboxProps {
	fieldData: Field;
	label: string;
	checkboxProps: CheckboxProps;
}

const FormCheckbox: React.FC<FormCheckboxProps> = ({ fieldData, label, checkboxProps }) => {
	const helperText = getHelperText(fieldData);

	return (
		<FormGroup>
			<FormControlLabel
				control={
					<Checkbox
						checked={Boolean(fieldData.value)}
						color={fieldData.error ? 'error' : 'primary'}
						{...checkboxProps}
						data-testid={`${checkboxProps.name}-checkbox`}
					/>
				}
				label={label}
				required={fieldData.required}
				color={fieldData.error ? 'error' : 'primary'}
			/>
			{helperText && (
				<FormHelperText error={fieldData.error} disabled={checkboxProps.disabled}>
					{helperText}
				</FormHelperText>
			)}
		</FormGroup>
	);
};

export default FormCheckbox;
